import { z } from 'zod'

/**
 * Where a private answer sits for the venue. Mirrors `CoupleFeedbackStatus`
 * (`check:enums`). `noted` is praise. The others are work.
 */
export const COUPLE_FEEDBACK_STATUSES = ['new', 'in_progress', 'resolved', 'noted'] as const

export const coupleFeedbackStatusSchema = z.enum(COUPLE_FEEDBACK_STATUSES)

export type CoupleFeedbackStatus = z.infer<typeof coupleFeedbackStatusSchema>

/** Statuses a venue can move a "needs attention" answer through. Praise stays `noted`. */
export const COUPLE_FEEDBACK_WORK_STATUSES = ['new', 'in_progress', 'resolved'] as const satisfies readonly CoupleFeedbackStatus[]
